/**
 * 错误码
 */
const errorCode = {
  SUCCESS: {
    code: 0,
    msg: '成功'
  },
  ACCESSTOKEN_INVALID: {
    code: 1200001,
    msg: '访问凭据无效,请重新登录'
  },
  LOGIN_MUTEX: {
    code: 1200034,
    msg: '您已在别处登录'
  },
  EMAIL_EXISTED: {
    code: 1200014,
    msg: '邮箱已存在'
  },
  PHONE_EXISTED: {
    code: 1200015,
    msg: '手机号已存在'
  },
  LOGINNAME_EXISTED: {
    code: 1200019,
    msg: '登录名已存在'
  },
  USER_LOGIN_RESTRICT: {
    code: 1209013,
    msg: '登录次数超出限制'
  }
}
export default errorCode



// WEBPACK FOOTER //
// ./src/utils/errorCode.js